import React from "react"
export function MealsFill(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10 2a8 8 0 110 16 8 8 0 010-16zM7.693 6.571h-.55v2.22c0 .452.336.826.77.88l.11.007v3.75h.88v-3.75a.883.883 0 00.873-.776l.007-.111V6.57h-.55v1.554a.221.221 0 01-.22.222.22.22 0 01-.213-.163l-.008-.06V6.572h-.659v1.554a.221.221 0 01-.22.222.22.22 0 01-.212-.163l-.008-.06V6.572zm4.593 0h-.44c-.744 0-1.178 1.474-1.304 4.42a.443.443 0 00.342.452l.08.01h.442v1.972h.88V6.571z"
        fill="currentColor"
        id="prefix__meals---fill"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
